'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _class2, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _components2 = require('components');

var _forms = require('metadata/forms');

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SeparatedDateInput: {
        displayName: 'SeparatedDateInput'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/forms/SeparatedDateInput.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var HelpText = function HelpText(_ref) {
    var helpText = _ref.helpText;
    return _react3.default.createElement(
        'div',
        null,
        helpText && _react3.default.createElement(
            'div',
            { className: 'help-field' },
            helpText
        )
    );
};

HelpText = (0, _pacomo.pacomoTransformer)(HelpText);

var SeparatedDateInput = _wrapComponent('SeparatedDateInput')((0, _reactIntl.injectIntl)(_class = (0, _pacomo.pacomoDecorator)(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(SeparatedDateInput, _Component);

    function SeparatedDateInput(props) {
        (0, _classCallCheck3.default)(this, SeparatedDateInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SeparatedDateInput.__proto__ || (0, _getPrototypeOf2.default)(SeparatedDateInput)).call(this, props));

        _this.onChangeGenerator = function (dateUnit) {
            var input = _this.props.input;

            if (dateUnit === 'day' || dateUnit === 'year') {
                return function (event) {
                    if (event && event.target) {
                        _this.setState((0, _defineProperty3.default)({}, dateUnit, event.target.value));
                    }
                };
            } else if (dateUnit === 'month') {
                return function (option) {
                    if (option) {
                        _this.setState({ month: option.value });
                    } else {
                        // When the user clears the month option is null
                        _this.setState({ month: '' });
                    }
                };
            }
        };

        _this.onBlur = function () {
            var input = _this.props.input;

            input.onBlur(_this.stringifyDate(_this.state));
        };

        _this.state = {
            year: '',
            month: '',
            day: '',
            yearTouched: false
        };
        return _this;
    }

    (0, _createClass3.default)(SeparatedDateInput, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setStateToDateString(this.props.input.value);
        }
        // componentWillReceiveProps(nextProps) {
        //     this.setStateToDateString(nextProps.input.value)
        // }

        // shouldComponentUpdate(nextProps, nextState) {
        //     // Trigger update if the prop value or the state changes
        //     return nextProps.input.value !== this.props.input.value ||
        //         nextState !== this.state
        // }

    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var input = this.props.input;
            // Trigger onChange event iff state has changed

            if (prevState !== this.state) {
                input.onChange(this.stringifyDate(this.state));
            }
        }
    }, {
        key: 'setStateToDateString',
        value: function setStateToDateString(dateString) {
            if (dateString) {
                this.setState(this.parseDateString(dateString));
            }
        }
    }, {
        key: 'parseDateString',
        value: function parseDateString(dateString) {
            // We can always assume that the dateString is provided to use in the
            var _dateString$split = dateString.split('-'),
                _dateString$split2 = (0, _slicedToArray3.default)(_dateString$split, 3),
                year = _dateString$split2[0],
                month = _dateString$split2[1],
                day = _dateString$split2[2];

            // Remove leading 0 if necessary to hide that detail from the user


            if (day.length === 2 && day[0] === '0') {
                day = day[1];
            }
            return { year: year, month: month, day: day };
        }
    }, {
        key: 'stringifyDate',
        value: function stringifyDate(_ref2) {
            var year = _ref2.year,
                month = _ref2.month,
                day = _ref2.day;

            if (year && month && day) {
                if (day.length === 1 && day > 0 && day < 10) {
                    // Must return 2 digit day in dates for API to accept value
                    return year + '-' + month + '-0' + day;
                } else {
                    return year + '-' + month + '-' + day;
                }
            }
            // else
            return '';
        }

        // class property to bind 'this' context

        // class property to bind 'this' context

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                intl = _props.intl,
                id = _props.id,
                requirement = _props.requirement,
                _props$meta = _props.meta,
                error = _props$meta.error,
                touched = _props$meta.touched,
                helpText = _props.helpText;
            var _state = this.state,
                year = _state.year,
                month = _state.month,
                day = _state.day;


            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'wrapper ' + (requirement ? 'isPartOfReqForm' : '') },
                    _react3.default.createElement(
                        'div',
                        { className: 'sub-field month' },
                        _react3.default.createElement(
                            'label',
                            { htmlFor: id + '_date-month' },
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'separatedDateInput.month',
                                defaultMessage: 'Month' })
                        ),
                        _react3.default.createElement(_reactSelect2.default, {
                            id: id + '_date-month',
                            value: this.state.month,
                            onChange: this.onChangeGenerator('month'),
                            onBlur: this.onBlur,
                            disabled: requirement && !requirement.editable,
                            options: (0, _keys2.default)(_forms.formOptions.monthLabels).map(function (key) {
                                return {
                                    label: intl.formatMessage(_forms.formOptions.monthLabels[key]),
                                    value: _forms.formOptions.monthValues[key]
                                };
                            }) })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'sub-field day' },
                        _react3.default.createElement(
                            'label',
                            { htmlFor: id + '_date-day' },
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'separatedDateInput.day',
                                defaultMessage: 'Day' })
                        ),
                        _react3.default.createElement('input', {
                            type: 'text',
                            maxLength: '2',
                            value: this.state.day,
                            onChange: this.onChangeGenerator('day'),
                            disabled: requirement && !requirement.editable,
                            onBlur: this.onBlur })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'sub-field year' },
                        _react3.default.createElement(
                            'label',
                            { htmlFor: id + '_date-year' },
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'separatedDateInput.year',
                                defaultMessage: 'Year' })
                        ),
                        _react3.default.createElement('input', {
                            type: 'text',
                            maxLength: '4',
                            value: this.state.year,
                            onChange: this.onChangeGenerator('year'),
                            disabled: requirement && !requirement.editable,
                            onBlur: function onBlur() {
                                if (!_this2.state.yearTouched) {
                                    _this2.setState({ yearTouched: true });
                                }
                                _this2.onBlur();
                            } })
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'error' },
                    _react3.default.createElement(_components2.FieldHelpErrorText, { touched: true, error: error })
                ),
                helpText && _react3.default.createElement(
                    'div',
                    { className: 'error' },
                    _react3.default.createElement(HelpText, { helpText: helpText })
                )
            );
        }
    }]);
    return SeparatedDateInput;
}(_react2.Component), _class2.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    id: _propTypes2.default.string.isRequired,
    input: _propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        onBlur: _propTypes2.default.func.isRequired,
        onChange: _propTypes2.default.func.isRequired
    }),
    requirement: _propTypes2.default.object,
    meta: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class);

exports.default = SeparatedDateInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/SeparatedDateInput.js
// module id = 1350
// module chunks = 0